import { motion } from "framer-motion";
import { Phone, Mail, MessageCircle } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-32 lg:py-44 px-6 lg:px-10 border-t border-nova-line overflow-hidden"
    >
      <div className="orb orb-violet w-[380px] h-[380px] -top-20 left-1/2 -translate-x-1/2 opacity-25" />
      <div className="max-w-5xl mx-auto text-center">
        <div className="mono-label mb-4">[ 04 — Contact ]</div>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-bold tracking-tighter text-4xl lg:text-5xl text-nova-text leading-[1.05] mb-6"
        >
          Reach the <span className="gold-text italic font-light">CODER</span>.
        </motion.h2>
        <p className="text-nova-mute text-lg max-w-2xl mx-auto mb-14">
          Every inquiry is read personally and answered within 24 hours.
        </p>
      </div>

      <div className="max-w-4xl mx-auto grid sm:grid-cols-2 gap-4">
        <a
          href="tel:+916260943446"
          data-testid="about-contact-phone"
          className="group flex items-center gap-4 border border-nova-line p-6 hover:border-nova-gold/40 transition-colors"
        >
          <Phone className="w-5 h-5 text-nova-gold" strokeWidth={1.5} />
          <div>
            <div className="mono-label">Call direct</div>
            <div className="text-nova-text text-base font-medium">+91 6260943446</div>
          </div>
        </a>
        <a
          href="mailto:novacreationscodes@gmail.com"
          data-testid="about-contact-email"
          className="group flex items-center gap-4 border border-nova-line p-6 hover:border-nova-gold/40 transition-colors"
        >
          <Mail className="w-5 h-5 text-nova-gold" strokeWidth={1.5} />
          <div>
            <div className="mono-label">Email</div>
            <div className="text-nova-text text-base font-medium">novacreationscodes@gmail.com</div>
          </div>
        </a>
        <a
          href="https://wa.me/916260943446?text=Hi%2C%20I'm%20interested%20in%20Nova's%20services."
          target="_blank"
          rel="noreferrer"
          data-testid="about-contact-whatsapp"
          className="group flex items-center gap-4 border border-nova-line p-6 hover:border-nova-gold/40 transition-colors sm:col-span-2"
        >
          <MessageCircle className="w-5 h-5 text-nova-gold" strokeWidth={1.5} />
          <div>
            <div className="mono-label">WhatsApp</div>
            <div className="text-nova-text text-base font-medium">Chat with CODER</div>
          </div>
        </a>
      </div>
    </section>
  );
}
